/**
 * Who ended a cancelled order, in the admin's words (backend `orders.cancelled_by`):
 * the customer asked, the driver's delivery failed (courier abandoned/returned it,
 * customer not available, wrong address), or a store/admin decision. Unknown for orders
 * cancelled before 2026-10-01.
 */
export const CANCELLED_BY_LABEL: Record<string, string> = {
  customer: 'by customer',
  courier: 'by driver',
  deeliver: 'by Deeliver',
};

export function cancelledByLabel(order: { status?: string; cancelledBy?: string | null }): string | null {
  if (!['cancelled', 'returned'].includes(order.status ?? '')) return null;
  return (order.cancelledBy && CANCELLED_BY_LABEL[order.cancelledBy]) || null;
}
